class CollectionSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const slider = this.querySelector('.splide');
    if (!slider) return;

    const splide = new Splide(slider, {
      type: 'slide',
      perPage: 3,
      gap: '3rem',
      arrows: true,
      pagination: false,
      drag: 'free',
      snap: false,
      autoplay: false,
      perMove: 1,
      breakpoints: {
        1200: { perPage: 3 },
        1199: {
          perPage: 2,
          gap: '1rem'
        }
      }
    });

    splide.mount();
  }
}

customElements.define('collection-slider', CollectionSlider);


class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const splideEl = this.querySelector('.splide');

    if (!splideEl) return;

    this.splide = new Splide(splideEl, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '3rem',
      arrows: true,
      pagination: false,
      autoplay: false,
      interval: 3500,
      speed: 2000,
      pauseOnHover: true,
      breakpoints: {
        1199: {
          perPage: 2,
          gap: '1rem'
        },
        750: {
          perPage: 1
        }
      }
    });

    this.splide.mount();
  }
}

customElements.define('testimonial-slider', TestimonialSlider);

class CustomDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    // Close button inside component
    this.addEventListener('click', (e) => {
      if (e.target.closest('.cls-icn-wpr')) {
        this.removeAttribute('open');
      }
    });

    // Hamburger button outside component
    const hamburger = document.querySelector('.ham-icn-wpr');

    if (hamburger) {
      hamburger.addEventListener('click', () => {
        this.setAttribute('open', '');
      });
    }
  }
}

customElements.define('custom-drawer', CustomDrawer);


document.addEventListener("DOMContentLoaded", function () {
  const fileInput = document.getElementById("custom-file");

  if(!fileInput) return;


  const uploadWrapper = document.querySelector(".file_upload_input");
  const label = uploadWrapper.querySelector("label");
  const content = uploadWrapper.querySelector(".abs-cntn");

  fileInput.addEventListener("change", function () {
    const file = this.files[0];

    if (!file) return;

    // Convert file size to KB/MB
    const fileSize =
      file.size < 1024 * 1024
        ? (file.size / 1024).toFixed(1) + " KB"
        : (file.size / (1024 * 1024)).toFixed(1) + " MB";

    // Update UI
    content.innerHTML = `
      <div class="file-success">
        <strong>✔ ${file.name}</strong>
        <br>
        <span>${fileSize}</span>
        <br><br>
        <button type="button" class="remove-file">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M5.47 5.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06"/><path d="M18.53 5.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0"/></g></svg>
        </button>
      </div>
    `;

    // Remove file handler
    const removeBtn = uploadWrapper.querySelector(".remove-file");
    removeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      fileInput.value = ""; // Clear input
      content.innerHTML = `
        <strong>+ Upload Design</strong>
        <br>
        <span>(.jpg, .png, .pdf)</span>
      `;
    });
  });
});


